import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    auctionLimitPropertiesType,
    auctionLimitsType,
    sortingParamType,
} from '../../types';
import AuctionLimitRow from './AuctionLimitRow';
import SortControl from '../SortControl';

AuctionLimitsList.propTypes = {
    auctionLimits: auctionLimitsType.isRequired,
    auctionLimitProps: auctionLimitPropertiesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function AuctionLimitsList(props) {
    const {
        auctionLimits,
        auctionLimitProps,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="auction-limits-list">
            <div className="rich-list-row rich-list-header auction-limits-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="auction-limit-header--values--member">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="member.memberId">
                        {t('auction-limits.list-header.member')}
                    </SortControl>
                </div>
                <div className="auction-limit-header--values--product">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="product.productId">
                        {t('auction-limits.list-header.product')}
                    </SortControl>
                </div>
                <div className="auction-limit-header--values--limit">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="limit">
                        {t('auction-limits.list-header.limit')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                auctionLimits.length
                    ? auctionLimits.map((auctionLimit) => (
                        <AuctionLimitRow
                            auctionLimit={auctionLimit}
                            auctionLimitProps={auctionLimitProps}
                            key={auctionLimit.id}
                        />
                    ))
                    : (
                        <div className="auction-limits-no-items">
                            {t('auction-limits.no-items')}
                        </div>
                    )
            }
        </div>
    );
}

export default AuctionLimitsList;
